import React, { useEffect, useState } from 'react';

const ScrollTopButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.pageYOffset > 300);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll(); // initialize on mount

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      type="button"
      className={`scroll-to-top ${visible ? 'show' : ''}`}
      onClick={scrollToTop}
      onTouchEnd={(e) => { e.preventDefault(); scrollToTop(); }}
      aria-label="Back to top"
      style={{
        touchAction: 'manipulation',
        WebkitTapHighlightColor: 'rgba(55, 248, 255, 0.3)'
      }}
    >
      <i className="fas fa-arrow-up" aria-hidden="true"></i>
    </button>
  );
};

export default ScrollTopButton;

